import { Text } from "../../../../../../mads/Text";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { useIsMobile } from "../../../../context/ViewJobScreenDisplay";
import { CompanyNameSectionWithSubsidiaryInfo } from "../CompanyNameSectionWithSubsidiaryInfo";
import { CompanyOverviewLink } from "../CompanyOverviewLink";

import { colors, spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

export function CompanyNameSection({
  showRatings,
  isSimpleVjImproveActive = false,
}: {
  showRatings: boolean;
  isSimpleVjImproveActive?: boolean;
}) {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const isMobile = useIsMobile();

  const { companyName, companyOverviewLink, parentCompanyName } =
    viewjobOneGraphModel?.employer ?? {};
  const { country = "", isCondensedRating = false } = viewjobOneGraphModel?.features ?? {};

  if (!companyName) {
    return null;
  }

  if (parentCompanyName) {
    return (
      <CompanyNameSectionWithSubsidiaryInfo
        companyName={companyName}
        companyOverviewLink={companyOverviewLink}
        showRatings={showRatings}
        parentCompanyName={parentCompanyName}
        isSimpleVjImproveActive={isSimpleVjImproveActive}
        isCondensedRating={isCondensedRating}
        country={country}
      />
    );
  }

  if (!showRatings && isMobile) {
    return (
      <Text
        level={3}
        sx={[
          styles.mobileCompanyName,
          isSimpleVjImproveActive && styles.simpleVjColor,
          isCondensedRating && styles.condensedRatingColor,
        ]}
        testID="vj-company-name"
      >
        {companyName}
      </Text>
    );
  }

  if (companyOverviewLink) {
    return (
      <CompanyOverviewLink
        companyName={companyName}
        companyOverviewLink={companyOverviewLink}
        country={country}
        isSimpleVjImproveActive={isSimpleVjImproveActive}
      />
    );
  }

  return (
    <Text
      level={isMobile ? 2 : 3}
      sx={[isCondensedRating && styles.condensedRatingColor]}
      testID="vj-company-name"
    >
      {companyName}
    </Text>
  );
}

const styles = StyleSheet.create({
  mobileCompanyName: {
    marginRight: spacing.s2,
  },
  simpleVjColor: {
    color: colors.foreground,
  },
  condensedRatingColor: {
    color: colors.foregroundStrong,
  },
});
